module.exports = __webpack_public_path__ + "img/EgyptTechPriestHp1_ua.23e09dc7.webp";